<div class="flex justify-content-between full-width px-2" style="height: 50px;">
  <div class="flex justify-items-center align-items-center justify-content-center">
    <img *ngIf="showLogo && logo" [src]="logo" alt="image" class="h-2rem opacity-70">
    <div *ngIf="showTitle && title" class="flex align-items-center gap-2">
      <span class="text-xs font-semibold uppercase px-2 text-gray-700">{{ title }}</span>
    </div>
  </div>
  <div class="flex">
    <app-sentrynel-button class="pr-3" *ngIf="findSuperAdmin()"  disabled></app-sentrynel-button>
<!--     <app-setting-button class="pr-3"></app-setting-button> -->
    <app-user-avatar class="pr-3"></app-user-avatar>
  </div>
</div>

